// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"toggler_wrapper__3yqMl","label":"toggler_label__3rGiT","bad":"toggler_bad__MxEhb","good":"toggler_good__2_d18"};